export const ArrowDownPurple: React.FC = () => {
    return (
        <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.08203L5.5 6.08203L10 1.08203" stroke="#5E1BFF" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
